import { type AddTabPanelInfo, TOTAL_DETAIL } from '@/common/stores/slide-detail.logic';
import type { DetailParams } from './types';
import type { DatabaseInstanceDetailType } from './details.types';
import { getDetailInfo } from './instanceDetail.utils';
import {
  getShardedClusterDetailAddition,
  getNormalInstanceDetailAddition,
  getClusterDetailAddition,
} from './db';

type Params = DetailParams & {
  dbType?: string;
  detailType?: string;
};

export const useInstanceDetail = () => {
  const getInstanceDetailAddition = async (
    params: Params,
  ): Promise<Extract<AddTabPanelInfo, { type: DatabaseInstanceDetailType }>> => {
    const { instanceId } = params;

    let dbType = params.dbType;
    let detailType = params.detailType;

    if (!detailType || !dbType) {
      const detailInfo = await getDetailInfo(instanceId ?? '');
      detailType = detailInfo.detailType;
      dbType = detailInfo.dbType || params.dbType;
    }

    if (detailType === TOTAL_DETAIL.CLUSTER) {
      const { name, cluster } = getClusterDetailAddition(params);

      return {
        type: detailType,
        name,
        cluster: { ...cluster, dbType },
      };
    }

    if (detailType === TOTAL_DETAIL.SHARDED_CLUSTER) {
      const { name, instance, addition } = getShardedClusterDetailAddition(params);

      return { type: detailType, name, instance, addition };
    }

    const { name, instance } = getNormalInstanceDetailAddition(params);

    return { type: detailType as typeof TOTAL_DETAIL.INSTANCE, name, instance };
  };

  return {
    getInstanceDetailAddition,
  };
};
